export const EVENTS = {
  firework: "/iconFirework.png",
  smoke: "/iconSmoke.png",
};
